// extracted by mini-css-extract-plugin
export default {"container":"_2Aa9","table":"_2-t7"};